import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TransmedReceivingDetailWithProblems } from "../../../../dtos/transmed/process/receivingDetail";
import TransmedProcessSlide from "./slide";
import {
  faExclamationTriangle,
  faInfinity,
} from "@fortawesome/free-solid-svg-icons";
import TransmedReceiving from "../../../../dtos/transmed/process/receiving";

export const startBatch = (start: Date, batch: number): Date => {
  const batchesPerDay = 4;
  const days = Math.floor(batch / batchesPerDay);
  const extraBatchesLastDay = batch % batchesPerDay;

  let newStart = new Date(start);
  newStart.setDate(newStart.getDate() + days);
  switch (extraBatchesLastDay) {
    case 0:
      newStart.setHours(9, 0);
      break;
    case 1:
      newStart.setHours(12, 0);
      break;
    case 2:
      newStart.setHours(15, 0);
      break;
    case 3:
      newStart.setHours(18, 0);
      break;
    default:
      throw new Error("Invalid date calculation logic");
  }
  return newStart;
};

export const endBatch = (start: Date, batch: number): Date => {
  let date = startBatch(start, batch);
  date.setHours(date.getHours() + 2, 59, 59);
  return date;
};

function TransmedProcessDistribution(props: {
  start: Date;
  batch: number;
  receivings: TransmedReceiving[];
  details: TransmedReceivingDetailWithProblems[];
}) {
  return (
    <TransmedProcessSlide
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "var(--gap-medium)",
      }}
    >
      <h3>Distribuția locurilor</h3>
      <div>
        Fiecare participant are un interval de <b>3 ore</b> în care:
        <ul>
          <li>
            Își confirmă locul, dacă a fost repartizat la alegerea sa inițială,
          </li>
          <li>Alege un alt loc, în caz contrar.</li>
        </ul>
        Intervalul orar estimat în care va trebui să îți confirmi/alegi locul:
        <h1 style={{ color: "red", margin: "var(--gap-small) 0" }}>
          {startBatch(props.start, props.batch).toLocaleDateString("RO-ro")},
          <br />
          {startBatch(props.start, props.batch).toLocaleTimeString(
            "RO-ro"
          )} - {endBatch(props.start, props.batch).toLocaleTimeString("RO-ro")}
        </h1>
        În funcție de alegerile celor situați înaintea ta în clasament,{" "}
        <b>intervalul de distribuție poate fi decalat</b>. Intervalul orar de
        mai sus va fi actualizat în timp real pentru a putea fi informat cât mai
        din timp posibil.
        <div style={{ marginTop: "var(--gap-small)" }}>
          <b>Atenție!</b> Dacă vei depăși acest interval orar, locul tău va fi
          atribuit unei alte persoane. Dacă vei depși și intervalul orar imediat
          următor, îți vei pierde definitiv șansa de a participa la această
          ediție Transmed.
        </div>
      </div>
      <div>
        <h3>
          <span style={{ color: "var(--color-fasmr-blue)" }}>Live!</span> Locuri
          rămase disponibile
        </h3>
        <div
          style={{
            marginTop: "var(--gap-medium)",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            gap: "var(--gap-small)",
          }}
        >
          {props.details.map((receivingDetails) => (
            <div
              key={receivingDetails.id}
              className="surface"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "var(--gap-small)",
              }}
            >
              <h4>
                {props.receivings.find(
                  (r: TransmedReceiving) =>
                    r.lc.id === receivingDetails.receiver
                )?.lc.city ?? "Necunoscut"}
              </h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: "var(--gap-small)",
                }}
              >
                <button
                  type="button"
                  disabled={true}
                  className="button primary text"
                  style={{
                    backgroundColor:
                      (receivingDetails.accomodation_yes ?? 1) > 0
                        ? "var(--color-overlay)"
                        : undefined,
                    color: "var(--color-dark)",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span>Cu cazare</span>
                  <b
                    style={{
                      fontWeight: 600,
                      marginTop: "var(--gap-xs)",
                      fontSize: "var(--body-font-size)",
                      color:
                        (receivingDetails.accomodation_yes ?? 1) > 0
                          ? receivingDetails.warning_yes
                            ? "yellow"
                            : "var(--color-fasmr-blue)"
                          : "var(--color-dark)",
                    }}
                  >
                    {receivingDetails.warning_yes && (
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color="yellow"
                      />
                    )}{" "}
                    {receivingDetails.accomodation_yes ?? (
                      <FontAwesomeIcon icon={faInfinity} />
                    )}
                  </b>
                </button>
                <button
                  type="button"
                  disabled={true}
                  className="button primary text"
                  style={{
                    backgroundColor:
                      (receivingDetails.accomodation_no ?? 1) > 0
                        ? "var(--color-overlay)"
                        : undefined,
                    color: "var(--color-dark)",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span>Fără cazare</span>
                  <b
                    style={{
                      fontWeight: 600,
                      marginTop: "var(--gap-xs)",
                      fontSize: "var(--body-font-size)",
                      color:
                        (receivingDetails.accomodation_no ?? 1) > 0
                          ? receivingDetails.warning_no
                            ? "yellow"
                            : "var(--color-fasmr-blue)"
                          : "var(--color-dark)",
                    }}
                  >
                    {receivingDetails.warning_no && (
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        color="yellow"
                      />
                    )}{" "}
                    {receivingDetails.accomodation_no ?? (
                      <FontAwesomeIcon icon={faInfinity} />
                    )}
                  </b>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessDistribution;
